module.exports = "/_next/static/images/63d7d04a86bed31f26f252ed297c5597-frozen.svg";